document.documentElement.classList.add('wm-js');
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- scroll reveals ---------- */
  function initReveals() {
    var rises = document.querySelectorAll('.wm-rise');
    if (!rises.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(rises, function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });

    Array.prototype.forEach.call(rises, function (el) { io.observe(el); });
  }

  /* ---------- trail spine ---------- */
  function initTrail() {
    var trail = document.querySelector('[data-wm-trail]');
    if (!trail) return;

    var links = Array.prototype.slice.call(trail.querySelectorAll('.wm-trail__link'));
    if (!links.length) { trail.style.display = 'none'; return; }

    // Resolve each blaze to the section it points at. Drop any that are missing.
    var stops = [];
    links.forEach(function (link) {
      var id = link.getAttribute('href');
      var target = id && id.charAt(0) === '#' ? document.querySelector(id) : null;
      if (target) {
        stops.push({ link: link, section: target });
      } else {
        link.parentNode.removeChild(link.closest('li') || link);
      }
    });
    if (!stops.length) { trail.style.display = 'none'; return; }

    var themed = Array.prototype.slice.call(document.querySelectorAll('[data-wm-theme]'));

    function sync() {
      var line = window.innerHeight * 0.42;
      var active = 0;

      stops.forEach(function (stop, i) {
        if (stop.section.getBoundingClientRect().top <= line) active = i;
      });

      stops.forEach(function (stop, i) {
        stop.link.classList.toggle('is-here', i === active);
        stop.link.classList.toggle('is-passed', i < active);
      });

      var current = null;
      themed.forEach(function (sec) {
        var rect = sec.getBoundingClientRect();
        if (rect.top <= line && rect.bottom > line) current = sec;
      });

      var isDark = current ? current.getAttribute('data-wm-theme') === 'dark' : true;
      trail.classList.toggle('on-dark', isDark);
      trail.classList.toggle('on-light', !isDark);
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { sync(); ticking = false; });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    sync();
  }

  /* ---------- capture: client-side email check before submit ---------- */
  function initCapture() {
    var boxes = document.querySelectorAll('[data-wm-capture]');
    Array.prototype.forEach.call(boxes, function (box) {
      var form = box.querySelector('form');
      var input = box.querySelector('.wm-capture__input');
      var error = box.querySelector('[data-wm-capture-error]');
      if (!form || !input) return;

      form.addEventListener('submit', function (event) {
        var value = (input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          event.preventDefault();
          if (error) {
            error.textContent = 'That email address doesn\u2019t look right. Check it and try again.';
            error.hidden = false;
          }
          input.focus();
        }
      });

      input.addEventListener('input', function () {
        if (error) error.hidden = true;
      });
    });
  }

  function boot() {
    initReveals();
    initTrail();
    initCapture();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-run when the theme editor swaps a section in or out.
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', boot);
})();